import { useGetList, useTranslate } from "ra-core";
import { cn } from "@/lib/utils";
import type { Task } from "../types";

// A collaboration is the set of tasks sharing a collaboration_id — one member
// task per person. Its completion is derived: done when all members are done.
// Shows "Collaboration · 1/2"; reads every member (RLS lets a user read all
// tasks), so the count is right even though the viewer only owns one member.
export function CollaborationBadge({
  collaborationId,
  className,
}: {
  collaborationId: string;
  className?: string;
}) {
  const translate = useTranslate();
  const { data } = useGetList<Task>("tasks", {
    filter: { collaboration_id: collaborationId },
    pagination: { page: 1, perPage: 50 },
    sort: { field: "id", order: "ASC" },
  });

  if (!data?.length) return null;

  const total = data.length;
  const done = data.filter((task) => task.done_date != null).length;
  const complete = done === total;
  const label = translate("resources.tasks.collaboration");

  return (
    <span
      title={label}
      className={cn(
        "inline-flex items-center text-xs px-1.5 py-0.5 rounded bg-muted align-middle",
        complete
          ? "text-green-700 dark:text-green-400"
          : "text-muted-foreground",
        className,
      )}
    >
      {label} · {done}/{total}
    </span>
  );
}
